import { http } from "../../config/HttpCommon";


export const getAssetGroup = async (groupBy: string) => {
  const response = await http.get(`/getAssetGroup/?GroupBy=${groupBy}`);
  return response.data;
};
